import {
  SET_WATCH_FEATURED,
  SET_NOW_SHOWING,
  SET_COMING_SOON,
  SET_MOVIE_MODAL_DATA,
  SET_MOVIE_MODAL_STATUS,
  SET_TICKET_COUNT,
  // TODO: import action types added later
} from './types'

function setWatchFeatured(watchFeatured) {
  return {
    type: SET_WATCH_FEATURED,
    payload: {
      watchFeatured,
    },
  }
}
function setNowShowing(nowShowing) {
  return {
    type: SET_NOW_SHOWING,
    payload: {
      nowShowing,
    },
  }
}
function setComingSoon(comingSoon) {
  return {
    type: SET_COMING_SOON,
    payload: {
      comingSoon,
    },
  }
}
function setMovieModalData(movieModalData) {
  return {
    type: SET_MOVIE_MODAL_DATA,
    payload: {
      movieModalData,
    },
  }
}
function setMovieModalStatus(movieModalStatus) {
  return {
    type: SET_MOVIE_MODAL_STATUS,
    payload: {
      movieModalStatus,
    },
  }
}
function setTicketCount(ticketCount) {
  return {
    type: SET_TICKET_COUNT,
    payload: {
      ticketCount,
    },
  }
}
// TODO: add more action creators

export {
  setWatchFeatured,
  setNowShowing,
  setComingSoon,
  setMovieModalData,
  setMovieModalStatus,
  setTicketCount,
  // TODO: export action creators added later
}
